export default __webpack_public_path__ + "static/media/close.ea9d90a1.svg";